var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-7 flex items-center justify-center"},[_c('img',{attrs:{"src":require('../assets/icons/raditubelogo.svg'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }